<div class="lvi-content" [ngClass]="{ clickable: isWithChevron() }" (click)="isChevronOpen = !isChevronOpen">
    <div class="avatar">
        <i *ngIf="data.nature == TypeNature.MONTANT" class="material-icons">savings</i>
        <i *ngIf="data.nature == TypeNature.ENVELOPPE" class="material-icons">mail_outline</i>
        <i *ngIf="data.nature == TypeNature.ANALYTIQUE" class="nio icon-note_de_frais" style="vertical-align: middle;"></i>
        <i *ngIf="data.nature == TypeNature.REAFFECTATION" class="material-icons">sync_alt</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ ('admin.entreprise.analytique.enveloppes.historique.typeNature.' + data.nature) | translate }} : {{ data.reference }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.entreprise.analytique.enveloppes.historique.origine'"></strong>
                <span [translate]="'admin.entreprise.analytique.enveloppes.historique.typeSource.' + data.sourceLog"></span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.analytique.enveloppes.historique.date'"></strong>
                <span>{{ data.dateLog | date:'short' }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.analytique.enveloppes.historique.acteur'"></strong>
                <span>{{ data.acteur | user }}</span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.analytique.enveloppes.historique.typeModif'"></strong>
                <span [translate]="'admin.entreprise.analytique.enveloppes.historique.typeLog.' + data.typeLog"></span>
            </li>
            <li>
                <strong [translate]="'admin.entreprise.analytique.enveloppes.historique.zone'"></strong>
                <span [translate]="'admin.entreprise.analytique.enveloppes.historique.typeNature.' + data.nature"></span>
            </li>
        </ul>
    </div>

    <div class="lvi-actions" *ngIf="isWithChevron()">
        <button mat-icon-button>
            <mat-icon *ngIf="isChevronOpen" color="primary">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!isChevronOpen" color="primary">keyboard_arrow_down</mat-icon>
        </button>
    </div>
</div>


<div *ngIf="isChevronOpen && isWithChevron()" class="p-20">
    <form autocomplete="off" #formFrais="ngForm">
        <div *ngFor="let historiqueEnveloppeChangeViews of data.listeHistoriqueEnveloppeChange">
            <div class="row">
                <div class="col-md-8">
                    <div class="row">
                        <label class="col-md-3">
                            <span [translate]="('admin.entreprise.analytique.enveloppes.historique.chevron.'+historiqueEnveloppeChangeViews.clef)"></span>
                        </label>
                        <div class="col-md-9">
                            <span>{{ formatLog(historiqueEnveloppeChangeViews) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>